import classNames from 'classnames'
import { DataItem } from 'scrivito'

import { Badge, Variant } from '@/Atomic/Atoms/Badge'
import { DataItemLink } from '@/Atomic/Atoms/DataItemLink'
import { StringText } from '@/Atomic/Atoms/StringText'
import { Avatar } from '@/Atomic/Molecules/Avatar'
import { DataBinary } from '@/utils/dataBinaryToUrl'

interface ItemContentProps {
  avatar?: string | DataBinary
  avatarIcon?: string
  fallbackInitials?: string
  /** Stable value, usually the entity ID, used to choose the initials color. */
  initialsColorSeed?: string
  title?: string
  subtitle?: string
  badgeValue?: string | string[]
  badgeVariant?: Variant
  secondaryBadgeValue?: string
  secondaryBadgeVariant?: Variant
  dataItem?: DataItem
  onClick?: (e: React.MouseEvent) => void
  showButton?: 'always' | 'onHover'
  button?: React.ReactNode
}

export const SublistItemContent: React.FC<ItemContentProps> = ({
  avatar,
  avatarIcon,
  fallbackInitials,
  initialsColorSeed,
  title,
  subtitle,
  badgeValue,
  badgeVariant,
  secondaryBadgeValue,
  secondaryBadgeVariant,
  dataItem,
  onClick,
  showButton = 'always',
  button,
}) => {
  const contentChildren = (
    <>
      <div className="first-line">
        <StringText
          variant="title"
          wrapperClassName="title-wrapper"
          className="text"
        >
          {title}
        </StringText>
        {badgeValue && <Badge value={badgeValue} variant={badgeVariant} />}
        {secondaryBadgeValue && (
          <Badge value={secondaryBadgeValue} variant={secondaryBadgeVariant} />
        )}
      </div>
      <StringText
        variant="subtitle"
        wrapperClassName="text-wrapper"
        className="text"
      >
        {subtitle}
      </StringText>
    </>
  )

  return (
    <div
      className={classNames('sublist-item-content', showButton, {
        pointer: !!dataItem || !!onClick,
      })}
    >
      <Avatar
        avatar={avatar}
        icon={avatarIcon}
        initials={fallbackInitials}
        initialsColorSeed={initialsColorSeed}
      />
      {dataItem ? (
        <DataItemLink dataItem={dataItem} className="content">
          {contentChildren}
        </DataItemLink>
      ) : (
        <div className="content" onClick={onClick}>
          {contentChildren}
        </div>
      )}
      {button && (
        <div className={classNames('button', showButton)}>{button}</div>
      )}
    </div>
  )
}
